export default __webpack_public_path__ + "static/media/choose-cards.4865033a.svg";